import { useCallback, useState } from 'react';

interface ConfirmState {
  msg: string;
  action: () => void;
}

/** Estado de um diálogo de confirmação de ação destrutiva (usar com <ConfirmDialog>). */
export function useConfirm() {
  const [confirmState, setConfirmState] = useState<ConfirmState | null>(null);

  const confirmar = useCallback((msg: string, action: () => void) => {
    setConfirmState({ msg, action });
  }, []);

  const fechar = useCallback(() => setConfirmState(null), []);

  return { confirmState, confirmar, fechar };
}
